import { Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, Transition as _Transition, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71706a98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "organization-view" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "d-flex justify-content-between row g-0" }
const _hoisted_4 = { class: "col text-wrap text-truncate" }
const _hoisted_5 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_6 = {
  class: "new-name",
  key: "noname"
}
const _hoisted_7 = { class: "d-flex flex-column flex-sm-row text-end" }
const _hoisted_8 = { class: "me-sm-2 mb-2 mb-sm-0" }
const _hoisted_9 = {
  key: 0,
  class: "dt-container dt-container--tabbed"
}
const _hoisted_10 = {
  key: 0,
  class: "callout callout--no-max callout--danger mb-3"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--danger",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_12 = {
  key: 1,
  class: "callout callout--no-max callout--danger mb-3"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--danger",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Organization does not have a Ditto Plan.", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Name of the organization", -1))
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Billing type used for organization. If a organization is on PO they can't go straight to Stripe. Make it a Trial and allow the org to enter a credit card.", -1))
const _hoisted_21 = { class: "col" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Limit or active receivers allowed for the organization", -1))
const _hoisted_23 = { class: "col" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Date of expiration on organization", -1))
const _hoisted_25 = {
  key: 2,
  class: "row"
}
const _hoisted_26 = { class: "col" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Billing frequency for organization.", -1))
const _hoisted_28 = { class: "col" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Id we use to link the org to a stripe customer", -1))
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-sm-6" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ditto plan for organization", -1))
const _hoisted_36 = { class: "row mb-3" }
const _hoisted_37 = { class: "col-sm-6" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Plan Limit Usage", -1))
const _hoisted_39 = { class: "fw-bold" }
const _hoisted_40 = { class: "col-sm-6" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Usage Prevents Plan Changes", -1))
const _hoisted_42 = { class: "fw-bold" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 3 }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Ditto Plan Overrides", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enter 0 for unlimited.", -1))
const _hoisted_48 = { class: "row mt-2" }
const _hoisted_49 = { class: "col-sm-6" }
const _hoisted_50 = { class: "col-sm-6" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-sm-6" }
const _hoisted_53 = {
  key: 1,
  class: "row"
}
const _hoisted_54 = { class: "col-sm-6" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "This organization does not have any plan overrides. Click below to create one.", -1))
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-sm-6" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Allow the usage of non SSP receivers", -1))
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-sm-6" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Allow the displaying of usage stats on the organizations portal", -1))
const _hoisted_62 = { class: "col-sm-6" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Allow Ditto Connect app to report usage stats to us", -1))
const _hoisted_64 = {
  key: 4,
  class: "row"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Show the deployment options (Auto-Create Rooms & Auto-Link Receivers to Rooms)", -1))
const _hoisted_66 = {
  key: 5,
  class: "row"
}
const _hoisted_67 = { class: "col-sm-6" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "This organization is missing it's deployment section. Click below to create one.", -1))
const _hoisted_69 = { class: "w-25" }
const _hoisted_70 = {
  key: 6,
  class: "row"
}
const _hoisted_71 = { class: "col-sm-6" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Auto create rooms when devices are deployed using MDM (User can manage this when \"Show Deployment Options Enabled\")", -1))
const _hoisted_73 = { class: "col-sm-6" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Auto link receivers to created room when deployed with MDM (User can manage this when \"Show Deployment Options Enabled\")", -1))
const _hoisted_75 = { key: 0 }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_79 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Organization has no users", -1))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { key: 1 }
const _hoisted_84 = { class: "inventory-table__actions d-sm-flex align-items-end my-3" }
const _hoisted_85 = {
  key: 0,
  class: "room-details"
}
const _hoisted_86 = { class: "d-flex flex-row" }
const _hoisted_87 = { class: "expand-column" }
const _hoisted_88 = {
  key: 0,
  class: "d-flex flex-row m-2"
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Enforce static IP address", -1))
const _hoisted_90 = {
  key: 1,
  class: "d-flex flex-row m-2"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "IP Address", -1))
const _hoisted_92 = {
  key: 2,
  class: "d-flex flex-row m-2"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "MAC Address", -1))
const _hoisted_94 = {
  key: 3,
  class: "d-flex flex-row m-2"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Last Known IP Address", -1))
const _hoisted_96 = {
  key: 0,
  class: "expand-label ms-2 mt-2"
}
const _hoisted_97 = {
  key: 1,
  class: "d-flex flex-row"
}
const _hoisted_98 = { class: "expand-column" }
const _hoisted_99 = { class: "d-flex flex-row m-2" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Disable Screensaver", -1))
const _hoisted_101 = { class: "d-flex flex-row m-2" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Screen Dimming Percentage", -1))
const _hoisted_103 = {
  key: 0,
  class: "d-flex flex-row m-2"
}
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Display Fullscreen", -1))
const _hoisted_105 = {
  key: 1,
  class: "d-flex flex-row m-2"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Launch at Login", -1))
const _hoisted_107 = { class: "expand-column" }
const _hoisted_108 = { class: "d-flex flex-row m-2" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Security", -1))
const _hoisted_110 = {
  key: 0,
  class: "d-flex flex-row m-2"
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Security Code Position", -1))
const _hoisted_112 = { class: "expand-column" }
const _hoisted_113 = { class: "d-flex flex-row m-2" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Logging Level", -1))
const _hoisted_115 = {
  key: 0,
  class: "d-flex flex-row m-2"
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Use Classic Renderer", -1))
const _hoisted_117 = {
  key: 1,
  class: "d-flex flex-row m-2"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Allow AirPlay Connections", -1))
const _hoisted_119 = {
  key: 2,
  class: "d-flex flex-row m-2"
}
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Allow Cast Connections", -1))
const _hoisted_121 = {
  key: 3,
  class: "d-flex flex-row m-2"
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Allow Miracast Connections", -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label ms-2 mt-2" }, "Onboarding", -1))
const _hoisted_124 = { class: "d-flex flex-row" }
const _hoisted_125 = { class: "expand-column" }
const _hoisted_126 = { class: "d-flex flex-row m-2" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Active onboarding", -1))
const _hoisted_128 = {
  key: 0,
  class: "expand-column"
}
const _hoisted_129 = { class: "d-flex flex-row m-2" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Onboarding user", -1))
const _hoisted_131 = {
  key: 1,
  class: "expand-column"
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row m-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Receiver can only be deleted by the onboarding user or the onboarding user must complete onboarding.")
], -1))
const _hoisted_133 = [
  _hoisted_132
]
const _hoisted_134 = { key: 0 }
const _hoisted_135 = { key: 0 }
const _hoisted_136 = {
  key: 1,
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_137 = ["d"]
const _hoisted_138 = { key: 1 }
const _hoisted_139 = { key: 0 }
const _hoisted_140 = { key: 1 }
const _hoisted_141 = { key: 0 }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_143 = { class: "inventory-table__actions d-sm-flex align-items-end my-3" }
const _hoisted_144 = { class: "room-details" }
const _hoisted_145 = {
  key: 0,
  class: "room-details__receivers"
}
const _hoisted_146 = {
  key: 1,
  class: "d-flex flex-row"
}
const _hoisted_147 = { class: "expand-column" }
const _hoisted_148 = { class: "d-flex flex-row m-2" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Enable Mirroring", -1))
const _hoisted_150 = {
  key: 0,
  class: "d-flex flex-row m-2"
}
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Enable Signage", -1))
const _hoisted_152 = {
  key: 1,
  class: "d-flex flex-row m-2"
}
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Enable Alerts", -1))
const _hoisted_154 = { class: "d-flex flex-row m-2" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Enable Native Resolution", -1))
const _hoisted_156 = { key: 0 }
const _hoisted_157 = { class: "expand-column" }
const _hoisted_158 = {
  key: 0,
  class: "d-flex flex-row m-2"
}
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Show Connection Info", -1))
const _hoisted_160 = {
  key: 1,
  class: "d-flex flex-row m-2"
}
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Connection Info Location", -1))
const _hoisted_162 = {
  key: 2,
  class: "d-flex flex-row m-2"
}
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Show Date and Time on Signage", -1))
const _hoisted_164 = { key: 0 }
const _hoisted_165 = {
  key: 3,
  class: "d-flex flex-row m-2"
}
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Date and Time Location", -1))
const _hoisted_167 = { key: 0 }
const _hoisted_168 = { class: "expand-column" }
const _hoisted_169 = {
  key: 0,
  class: "d-flex flex-row m-2"
}
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Enable Moderator Controls", -1))
const _hoisted_171 = {
  key: 1,
  class: "d-flex flex-row m-2"
}
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Moderator Connection Type", -1))
const _hoisted_173 = {
  key: 2,
  class: "d-flex flex-row m-2"
}
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Moderator Password", -1))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label ms-2 mt-2" }, "Onboarding", -1))
const _hoisted_176 = {
  key: 2,
  class: "d-flex flex-row"
}
const _hoisted_177 = { class: "expand-column" }
const _hoisted_178 = { class: "d-flex flex-row m-2" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Active onboarding", -1))
const _hoisted_180 = {
  key: 0,
  class: "expand-column"
}
const _hoisted_181 = { class: "d-flex flex-row m-2" }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expand-label" }, "Onboarding user", -1))
const _hoisted_183 = {
  key: 1,
  class: "expand-column"
}
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row m-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Room can only be deleted by the onboarding user or the onboarding user must complete onboarding.")
], -1))
const _hoisted_185 = [
  _hoisted_184
]
const _hoisted_186 = { key: 0 }
const _hoisted_187 = { key: 1 }
const _hoisted_188 = { key: 2 }
const _hoisted_189 = { key: 0 }
const _hoisted_190 = { key: 1 }
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "m-0" }, "Confirm Plan Change", -1))
const _hoisted_193 = { class: "dialog-footer" }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "m-0" }, "Stripe Refund", -1))
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "There are two methods for processing a Stripe refund.", -1))
const _hoisted_196 = ["href"]
const _hoisted_197 = { key: 0 }
const _hoisted_198 = { key: 1 }
const _hoisted_199 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_OrgUsageStatBarGraphs = _resolveComponent("OrgUsageStatBarGraphs")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_RoomsImport = _resolveComponent("RoomsImport")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, [
          (!_ctx.organization.id)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_router_link, {
                  class: "primary-color",
                  to: "/admin/organizations"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Organizations")
                  ]),
                  _: 1
                }),
                _createTextVNode(" » "),
                _createVNode(_Transition, {
                  name: "fade-in",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_ctx.organization.name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_TransitionGroup, {
                            class: "transition",
                            name: _ctx.organization.name.length > 1 ? 'fade-in' : '',
                            key: "name"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organization.name, (letter, i) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: "transition",
                                  key: i
                                }, _toDisplayString(letter), 1))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["name"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6))
                  ]),
                  _: 1
                })
              ], 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_button, {
            type: "info",
            onClick: _ctx.onCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode("Undo Changes")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            disabled: _ctx.saving,
            type: "primary",
            onClick: _ctx.onSubmitClick
          }, {
            default: _withCtx(() => [
              _createTextVNode("Save Organization")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    (_ctx.organization.billing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.activeTab,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.activeTab) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "Overview",
                name: "overview"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    ref: "form",
                    rules: _ctx.rules,
                    "label-position": "top",
                    model: _ctx.organization,
                    "label-width": "120px",
                    "hide-required-asterisk": ""
                  }, {
                    default: _withCtx(() => [
                      (_ctx.totalChangeText)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _hoisted_11,
                            _createElementVNode("span", null, _toDisplayString(_ctx.totalChangeText), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.organization.tierId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_form_item, {
                            prop: "name",
                            label: "Organization Name"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_17,
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.organization.name,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.organization.name) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_el_form_item, {
                            prop: "billing.billing_type",
                            label: "Billing Type"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_20,
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.organization.billing.billing_type,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.organization.billing.billing_type) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_tooltip, {
                                    disabled: _ctx.ogBillingType == 'Stripe',
                                    effect: "dark",
                                    content: "Cannot set type to Stripe. Set it to Trial and let the user start a Stripe subscription in the portal.",
                                    placement: "bottom",
                                    "hide-after": 0
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_option, {
                                        disabled: _ctx.ogBillingType != 'Stripe',
                                        label: "Stripe",
                                        value: "Stripe"
                                      }, null, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]),
                                  _createVNode(_component_el_option, {
                                    label: "PO",
                                    value: "PO"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Trial",
                                    value: "Trial"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_el_form_item, {
                            prop: "billing.subscription_limit",
                            label: "Active Room Subscription"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_22,
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.organization.billing.subscription_limit,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.organization.billing.subscription_limit) = $event)),
                                modelModifiers: { number: true }
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_el_form_item, {
                            prop: "billing.expiration_date",
                            label: "Expiration Date"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24,
                              _createVNode(_component_el_date_picker, {
                                disabled: _ctx.ogBillingType == 'Stripe',
                                modelValue: _ctx.organization.billing.expiration_date,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.organization.billing.expiration_date) = $event)),
                                type: "datetime",
                                placeholder: "Pick a Date",
                                format: "YYYY/MM/DD",
                                class: "w-100"
                              }, null, 8, ["disabled", "modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      (_ctx.ogBillingType == 'Stripe')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_el_form_item, {
                                prop: "billing.billingFrequency",
                                label: "Stripe Billing Frequency"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_27,
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.organization.billing.billingFrequency,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.organization.billing.billingFrequency) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_option, {
                                        label: "Yearly",
                                        value: "year"
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "Monthy",
                                        value: "month"
                                      }),
                                      (_ctx.showDaily)
                                        ? (_openBlock(), _createBlock(_component_el_option, {
                                            key: 0,
                                            label: "Daily",
                                            value: "day"
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_el_form_item, {
                                prop: "billing.customer_id",
                                label: "Stripe Customer ID"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_29,
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.organization.billing.customer_id,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.organization.billing.customer_id) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_el_form_item, {
                                prop: "billing.stripeRefundAmount",
                                label: "Stripe Refund"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.currentRefundAmount)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Refund amount available: $" + _toDisplayString(_ctx.currentRefundAmount), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_32, "No refund available")),
                                  _createVNode(_component_el_button, {
                                    class: "mt-1",
                                    disabled: !_ctx.currentRefundAmount,
                                    type: "primary",
                                    onClick: _ctx.onRefundClick
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Refund")
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "onClick"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_el_form_item, {
                            prop: "tierId",
                            label: "Ditto Plan"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_35,
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.organization.tierId,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.organization.tierId) = $event)),
                                placeholder: "Select Tier"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTiers, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.name,
                                      value: item.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("h2", null, "Current Plan: " + _toDisplayString(_ctx.currentPlanName), 1),
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createVNode(_component_el_table, {
                            data: _ctx.orgLimitUsage,
                            "show-header": false,
                            "row-class-name": _ctx.tableRowClassName
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, { width: "300" }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_39, _toDisplayString(scope.row.limitName), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, null, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", null, _toDisplayString(scope.row.limit), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data", "row-class-name"])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createVNode(_component_el_table, {
                            data: _ctx.userControlledFeatures,
                            "show-header": false,
                            "row-class-name": _ctx.tableRowClassName
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, null, {
                                default: _withCtx((scope) => [
                                  _createVNode(_component_el_tooltip, {
                                    placement: "bottom",
                                    "show-after": "500",
                                    disabled: !scope.row.description
                                  }, {
                                    content: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(scope.row.description), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_42, [
                                        _createTextVNode(_toDisplayString(scope.row.name) + " ", 1),
                                        (scope.row.description)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              class: "icon icon--small icon--info me-2",
                                              icon: _ctx.mdiInformationOutline
                                            }, null, 8, ["icon"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, { width: "100" }, {
                                default: _withCtx((scope) => [
                                  (_ctx.checkFeature(scope.row.id))
                                    ? (_openBlock(), _createBlock(_component_Icon, {
                                        key: 0,
                                        class: "icon icon--large icon--color",
                                        icon: _ctx.mdiCheckBold
                                      }, null, 8, ["icon"]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_43))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data", "row-class-name"])
                        ])
                      ]),
                      (_ctx.isPO)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            (_ctx.selectedTier && _ctx.organization.restrictions)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                  _hoisted_46,
                                  _hoisted_47,
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                      _createVNode(_component_el_form_item, {
                                        prop: "restrictions.restrictionUsers",
                                        label: "Number of Users"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.selectedTier.name) + " allows for " + _toDisplayString(_ctx.formatTierRestriction(_ctx.selectedTier.restrictionUsers)) + " users", 1),
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.organization.restrictions.restrictionUsers,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.organization.restrictions.restrictionUsers) = $event)),
                                            modelModifiers: { number: true }
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                      _createVNode(_component_el_form_item, {
                                        prop: "restrictions.restrictionReceivers",
                                        label: "Number of Receivers"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.selectedTier.name) + " allows for " + _toDisplayString(_ctx.formatTierRestriction(_ctx.selectedTier.restrictionReceivers)) + " receivers", 1),
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.organization.restrictions.restrictionReceivers,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.organization.restrictions.restrictionReceivers) = $event)),
                                            modelModifiers: { number: true }
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("div", _hoisted_52, [
                                      _createVNode(_component_el_form_item, {
                                        prop: "restrictions.restrictionStorageGBPerRec",
                                        label: "Storage in GB"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.selectedTier.name) + " allows for " + _toDisplayString(_ctx.formatTierRestriction(_ctx.selectedTier.restrictionStorageGBPerRec)) + " GB.", 1),
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.organization.restrictions.restrictionStorageGBPerRec,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.organization.restrictions.restrictionStorageGBPerRec) = $event)),
                                            modelModifiers: { number: true }
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _createVNode(_component_el_form_item, {
                                      prop: "createRestrictions",
                                      label: "Create Plan Overrides"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_55,
                                        _createVNode(_component_el_button, { onClick: _ctx.createPlanOverrides }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Create Plan Overrides")
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_divider, { class: "mt-0" }),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _createVNode(_component_el_form_item, {
                            prop: "allowlegacyReceivers",
                            label: "Legacy Receivers Enabled"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_58,
                              _createVNode(_component_el_switch, {
                                modelValue: _ctx.organization.featureFlags.allowlegacyReceivers,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.organization.featureFlags.allowlegacyReceivers) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createVNode(_component_el_form_item, {
                            prop: "usageStatsEnabled",
                            label: "Usage Stats Enabled"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_61,
                              _createVNode(_component_el_tooltip, {
                                disabled: _ctx.selectedTier.clientUsageStatsEnabled,
                                effect: "dark",
                                content: _ctx.planDisabledText,
                                placement: "bottom",
                                "hide-after": 0
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_switch, {
                                    disabled: !_ctx.selectedTier.clientUsageStatsEnabled,
                                    modelValue: _ctx.organization.clientUsageStats,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.organization.clientUsageStats) = $event))
                                  }, null, 8, ["disabled", "modelValue"])
                                ]),
                                _: 1
                              }, 8, ["disabled", "content"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _createVNode(_component_el_form_item, {
                            prop: "sendingUsageStatsEnabled",
                            label: "Sending Usage Stats Enabled"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_63,
                              _createVNode(_component_el_tooltip, {
                                disabled: _ctx.selectedTier.sendUsageStatsEnabled,
                                effect: "dark",
                                content: _ctx.planDisabledText,
                                placement: "bottom",
                                "hide-after": 0
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_switch, {
                                    disabled: !_ctx.selectedTier.sendUsageStatsEnabled,
                                    modelValue: _ctx.organization.sendUsageStats,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.organization.sendUsageStats) = $event))
                                  }, null, 8, ["disabled", "modelValue"])
                                ]),
                                _: 1
                              }, 8, ["disabled", "content"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      (_ctx.organization.deployment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _createElementVNode("div", null, [
                              _createVNode(_component_el_form_item, {
                                prop: "deployment.exposeAutoDeploymentOptions",
                                label: "Auto Deployment Options Enabled"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_65,
                                  _createVNode(_component_el_tooltip, {
                                    disabled: _ctx.selectedTier.mdmMassDeploymentEnabled,
                                    effect: "dark",
                                    content: _ctx.planDisabledText,
                                    placement: "bottom",
                                    "hide-after": 0
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_switch, {
                                        disabled: !_ctx.selectedTier.mdmMassDeploymentEnabled,
                                        modelValue: _ctx.organization.deployment.exposeAutoDeploymentOptions,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.organization.deployment.exposeAutoDeploymentOptions) = $event))
                                      }, null, 8, ["disabled", "modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "content"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                              _createVNode(_component_el_form_item, {
                                prop: "createDep",
                                label: "Create Deployment Properties"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_68,
                                  _createVNode(_component_el_tooltip, {
                                    disabled: _ctx.selectedTier.mdmMassDeploymentEnabled,
                                    effect: "dark",
                                    content: _ctx.planDisabledText,
                                    placement: "bottom",
                                    "hide-after": 0
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_69, [
                                        _createVNode(_component_el_button, {
                                          disabled: !_ctx.selectedTier.mdmMassDeploymentEnabled,
                                          onClick: _ctx.createDeploymentProperties
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Create Deployment Properties")
                                          ]),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "content"])
                                ]),
                                _: 1
                              })
                            ])
                          ])),
                      (_ctx.organization.deployment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            _createElementVNode("div", _hoisted_71, [
                              _createVNode(_component_el_form_item, {
                                prop: "deployment.autoCreateRooms",
                                label: "Auto Deployment Create Rooms"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_72,
                                  _createVNode(_component_el_tooltip, {
                                    disabled: _ctx.selectedTier.mdmMassDeploymentEnabled,
                                    effect: "dark",
                                    content: _ctx.planDisabledText,
                                    placement: "bottom",
                                    "hide-after": 0
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_switch, {
                                        disabled: !_ctx.selectedTier.mdmMassDeploymentEnabled,
                                        modelValue: _ctx.organization.deployment.autoCreateRooms,
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.organization.deployment.autoCreateRooms) = $event))
                                      }, null, 8, ["disabled", "modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "content"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_73, [
                              _createVNode(_component_el_form_item, {
                                prop: "deployment.autoLinkRooms",
                                label: "Auto Link Rooms"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_74,
                                  _createVNode(_component_el_tooltip, {
                                    disabled: _ctx.selectedTier.mdmMassDeploymentEnabled,
                                    effect: "dark",
                                    content: _ctx.planDisabledText,
                                    placement: "bottom",
                                    "hide-after": 0
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_switch, {
                                        disabled: !_ctx.selectedTier.mdmMassDeploymentEnabled,
                                        modelValue: _ctx.organization.deployment.autoLinkRooms,
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.organization.deployment.autoLinkRooms) = $event))
                                      }, null, 8, ["disabled", "modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "content"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["rules", "model"]),
                  (_ctx.organization.deployment)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_75, "Deployment Code: " + _toDisplayString(_ctx.organization.deployment.deploymentCode), 1))
                    : _createCommentVNode("", true),
                  _hoisted_76,
                  _createElementVNode("span", null, "Created: " + _toDisplayString(_ctx.organization.createdAt), 1),
                  _hoisted_77,
                  _createElementVNode("span", null, "Last Updated: " + _toDisplayString(_ctx.organization.updatedAt), 1),
                  _hoisted_78
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "Reports",
                name: "reports"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_OrgUsageStatBarGraphs, {
                    border: true,
                    organizationId: _ctx.organization.id
                  }, null, 8, ["organizationId"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "Users",
                name: "users"
              }, {
                default: _withCtx(() => [
                  (!_ctx.usersLoading && !_ctx.users)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, _hoisted_81))
                    : (_openBlock(), _createBlock(_component_el_table, {
                        key: 1,
                        data: _ctx.users,
                        ref: "usersTable"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "name",
                            label: "Name",
                            sortable: ""
                          }, {
                            default: _withCtx((scope) => [
                              _createVNode(_component_router_link, {
                                to: `/admin/users/${scope.row.id}`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.name) + " " + _toDisplayString(scope.row.isSSOGenerated ? '(SSO)' : ''), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "email",
                            label: "Email",
                            sortable: ""
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "role",
                            label: "Role",
                            sortable: ""
                          }, {
                            default: _withCtx((scope) => [
                              (scope.row.role)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(_ctx.getRoleName(scope.row.role)), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_83, "N/A"))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "Receivers",
                name: "receivers"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_84, [
                    _createVNode(_component_el_input, {
                      placeholder: "Search Receiver Names",
                      modelValue: _ctx.receiverSearch,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.receiverSearch) = $event)),
                      onKeyup: _ctx.handleReceiverSearchChange
                    }, null, 8, ["modelValue", "onKeyup"])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("div", null, [
                    _createVNode(_component_el_table, {
                      data: _ctx.receiverSearchResults,
                      ref: "receiversTable",
                      "empty-text": "Organization has no receivers",
                      onSortChange: _ctx.handleReceiverSortChange,
                      onExpandChange: _ctx.loadReceiverDetails,
                      "row-key": "id"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, { type: "expand" }, {
                          default: _withCtx((scope) => [
                            (scope.row.receiverDetails)
                              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_85, [
                                  _createElementVNode("div", _hoisted_86, [
                                    _createElementVNode("div", _hoisted_87, [
                                      (_ctx.isSSP(scope.row.receiverDetails.deviceType) && !(scope.row.receiverDetails.pairing && !scope.row.receiverDetails.pairing.isUsed))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                            _hoisted_89,
                                            _createVNode(_component_el_switch, {
                                              disabled: "",
                                              modelValue: scope.row.receiverDetails.manualIpAddressOverride,
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.receiverDetails.manualIpAddressOverride) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (scope.row.receiverDetails.manualIpAddressOverride || !_ctx.isSSP(scope.row.receiverDetails.deviceType) && scope.row.receiverDetails.manualIpAddresses)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                            _hoisted_91,
                                            _createVNode(_component_el_switch, {
                                              disabled: "",
                                              modelValue: scope.row.receiverDetails.manualIpAddresses[0],
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.receiverDetails.manualIpAddresses[0]) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      ((scope.row.receiverDetails.manualIpAddressOverride && !_ctx.isPlatform('tvos', scope.row.receiverDetails.platform)) || (!_ctx.isSSP(scope.row.receiverDetails.deviceType) && scope.row.receiverDetails.manualIpAddresses && !_ctx.isPlatform('tvos', scope.row.receiverDetails.platform)))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                            _hoisted_93,
                                            _createVNode(_component_el_switch, {
                                              disabled: "",
                                              modelValue: scope.row.receiverDetails.identifiers.mac,
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.receiverDetails.identifiers.mac) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (scope.row.receiverDetails.lastKnownIpAddress)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                            _hoisted_95,
                                            _createVNode(_component_el_switch, {
                                              disabled: "",
                                              modelValue: scope.row.receiverDetails.lastKnownIpAddress,
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.receiverDetails.lastKnownIpAddress) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  (_ctx.isSSP(scope.row.receiverDetails.deviceType))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_96, "Settings"))
                                    : _createCommentVNode("", true),
                                  (_ctx.isSSP(scope.row.receiverDetails.deviceType))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                        _createElementVNode("div", _hoisted_98, [
                                          _createElementVNode("div", _hoisted_99, [
                                            _hoisted_100,
                                            _createVNode(_component_el_switch, {
                                              disabled: "",
                                              modelValue: scope.row.receiverDetails.deviceSettings.general.disableScreensaver,
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.receiverDetails.deviceSettings.general.disableScreensaver) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_101, [
                                            _hoisted_102,
                                            _createTextVNode(_toDisplayString(scope.row.receiverDetails.deviceSettings.general.screenDimPercent), 1)
                                          ]),
                                          (_ctx.isPlatform('windows', scope.row.receiverDetails.platform))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                                _hoisted_104,
                                                _createVNode(_component_el_switch, {
                                                  disabled: "",
                                                  modelValue: scope.row.receiverDetails.deviceSettings.connection.displayFullscreen,
                                                  "onUpdate:modelValue": ($event: any) => ((scope.row.receiverDetails.deviceSettings.connection.displayFullscreen) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.isPlatform('windows', scope.row.receiverDetails.platform))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                                _hoisted_106,
                                                _createVNode(_component_el_switch, {
                                                  disabled: "",
                                                  modelValue: scope.row.receiverDetails.deviceSettings.advanced.launchAtLogin,
                                                  "onUpdate:modelValue": ($event: any) => ((scope.row.receiverDetails.deviceSettings.advanced.launchAtLogin) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_107, [
                                          _createElementVNode("div", _hoisted_108, [
                                            _hoisted_109,
                                            _createTextVNode(" " + _toDisplayString(_ctx.getSecurityDisplay(scope.row.receiverDetails.deviceSettings.connection.airPlaySecurity)), 1)
                                          ]),
                                          (!(scope.row.receiverDetails.deviceSettings.connection.airPlaySecurity=='none'))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                                _hoisted_111,
                                                _createTextVNode(" " + _toDisplayString(_ctx.getPositionDisplay(scope.row.receiverDetails.deviceSettings.general.onScreenCodePosition)), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_112, [
                                          _createElementVNode("div", _hoisted_113, [
                                            _hoisted_114,
                                            _createTextVNode(" " + _toDisplayString(_ctx.getLoggingDisplay(scope.row.receiverDetails.deviceSettings.advanced.loggingLevel)), 1)
                                          ]),
                                          (_ctx.isPlatform('windows', scope.row.receiverDetails.platform) && _ctx.isVersionLessThan(scope.row.receiverDetails,2,0,0))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                                _hoisted_116,
                                                _createVNode(_component_el_switch, {
                                                  disabled: "",
                                                  modelValue: scope.row.receiverDetails.deviceSettings.advanced.useClassicRenderer,
                                                  "onUpdate:modelValue": ($event: any) => ((scope.row.receiverDetails.deviceSettings.advanced.useClassicRenderer) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.isPlatform('windows', scope.row.receiverDetails.platform) && _ctx.isVersionLessThan(scope.row.receiverDetails,2,0,0))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                                _hoisted_118,
                                                _createVNode(_component_el_switch, {
                                                  disabled: "",
                                                  modelValue: scope.row.receiverDetails.deviceSettings.advanced.airplayEnabled,
                                                  "onUpdate:modelValue": ($event: any) => ((scope.row.receiverDetails.deviceSettings.advanced.airplayEnabled) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.isPlatform('windows', scope.row.receiverDetails.platform) && _ctx.isVersionLessThan(scope.row.receiverDetails,2,0,0))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                                _hoisted_120,
                                                _createVNode(_component_el_switch, {
                                                  disabled: "",
                                                  modelValue: scope.row.receiverDetails.deviceSettings.advanced.castEnabled,
                                                  "onUpdate:modelValue": ($event: any) => ((scope.row.receiverDetails.deviceSettings.advanced.castEnabled) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.isPlatform('windows', scope.row.receiverDetails.platform) && _ctx.isVersionLessThan(scope.row.receiverDetails,2,0,0))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                                _hoisted_122,
                                                _createVNode(_component_el_switch, {
                                                  disabled: "",
                                                  modelValue: scope.row.receiverDetails.deviceSettings.advanced.miracastEnabled,
                                                  "onUpdate:modelValue": ($event: any) => ((scope.row.receiverDetails.deviceSettings.advanced.miracastEnabled) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _hoisted_123,
                                  _createElementVNode("div", _hoisted_124, [
                                    _createElementVNode("div", _hoisted_125, [
                                      _createElementVNode("div", _hoisted_126, [
                                        _hoisted_127,
                                        _createVNode(_component_el_switch, {
                                          disabled: "",
                                          modelValue: scope.row.receiverDetails.isOnboarding,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.receiverDetails.isOnboarding) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ])
                                    ]),
                                    (scope.row.receiverDetails.onboardingUser)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                          _createElementVNode("div", _hoisted_129, [
                                            _hoisted_130,
                                            _createVNode(_component_router_link, {
                                              to: `/admin/users/${scope.row.receiverDetails.onboardingUser.id}`
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(scope.row.receiverDetails.onboardingUser.name), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["to"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (scope.row.receiverDetails.onboardingUser)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_131, _hoisted_133))
                                      : _createCommentVNode("", true)
                                  ])
                                ])), [
                                  [_directive_loading, !scope.row.receiverDetails || scope.row.expandReceiverLoading]
                                ])
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "id",
                          label: "Receiver ID",
                          sortable: "custom",
                          "show-overflow-tooltip": ""
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "displayName",
                          label: "Name",
                          sortable: "custom",
                          "show-overflow-tooltip": ""
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "deviceType",
                          label: "Device Type",
                          sortable: "custom",
                          "show-overflow-tooltip": ""
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(_ctx.getDeviceTypeDisplay(scope.row.deviceType)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "platform",
                          label: "Platform",
                          sortable: "custom",
                          "show-overflow-tooltip": ""
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(_ctx.getReceiverPlatformDisplay(scope.row.platform)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "lastKnownVersion",
                          label: "Version",
                          sortable: "custom",
                          "show-overflow-tooltip": ""
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "status",
                          label: "Status",
                          sortable: "custom"
                        }, {
                          default: _withCtx((scope) => [
                            (scope.row.room && scope.row.room._id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(`receiver-status__badge receiver-status__badge--${_ctx.receiverStatus(scope.row.status).toLowerCase()}`)
                                  }, [
                                    (_ctx.receiverStatus(scope.row.status).toLowerCase() != 'legacy')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_135, _toDisplayString(_ctx.receiverStatus(scope.row.status)), 1))
                                      : (_openBlock(), _createElementBlock("svg", _hoisted_136, [
                                          _createElementVNode("path", { d: _ctx.mdiHelp }, null, 8, _hoisted_137)
                                        ]))
                                  ], 2)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_138, "-"))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "room.roomName",
                          label: "Room",
                          sortable: "custom",
                          "show-overflow-tooltip": ""
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "location, id",
                          label: "Location",
                          sortable: "custom"
                        }, {
                          default: _withCtx((scope) => [
                            (scope.row.location && scope.row.location.parentId)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_139, _toDisplayString(scope.row.location.parentName), 1))
                              : (scope.row.location)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_140, _toDisplayString(scope.row.location.name), 1))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode("-")
                                  ], 64))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "location, id",
                          label: "Sublocation",
                          sortable: "custom"
                        }, {
                          default: _withCtx((scope) => [
                            (scope.row.location && scope.row.location.parentId)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_141, _toDisplayString(scope.row.location.name), 1))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("-")
                                ], 64))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data", "onSortChange", "onExpandChange"]),
                    _hoisted_142,
                    _createVNode(_component_el_pagination, {
                      class: "d-flex justify-content-center",
                      background: "",
                      layout: "prev, pager, next",
                      total: _ctx.receiverCount,
                      onCurrentChange: _ctx.handleReceiverCurrentPageChange,
                      "current-page": _ctx.receiverCurrentPage,
                      "onUpdate:currentPage": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.receiverCurrentPage) = $event))
                    }, null, 8, ["total", "onCurrentChange", "current-page"])
                  ])), [
                    [_directive_loading, _ctx.receiversLoading]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "Rooms",
                name: "rooms"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_143, [
                    _createVNode(_component_el_input, {
                      placeholder: "Search Room Names",
                      modelValue: _ctx.roomSearch,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.roomSearch) = $event)),
                      onKeyup: _ctx.handleRoomSearchChange
                    }, null, 8, ["modelValue", "onKeyup"])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("div", null, [
                    _createVNode(_component_el_table, {
                      data: _ctx.roomSearchResults,
                      ref: "roomsTable",
                      "empty-text": "Organization has no rooms",
                      onSortChange: _ctx.handleRoomSortChange,
                      onExpandChange: _ctx.loadRoomDetails,
                      "row-key": "id"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, { type: "expand" }, {
                          default: _withCtx((scope) => [
                            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_144, [
                              (scope.row.roomDetails)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                    _createVNode(_component_el_table, {
                                      data: scope.row.roomDetails.receivers,
                                      "empty-text": "Room has no receivers",
                                      border: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_table_column, {
                                          prop: "displayName",
                                          label: "Receiver Name"
                                        }),
                                        _createVNode(_component_el_table_column, {
                                          prop: "platform",
                                          label: "Platform"
                                        }, {
                                          default: _withCtx((scope) => [
                                            _createTextVNode(_toDisplayString(scope.row.platform) + " (" + _toDisplayString(scope.row.deviceType) + ") ", 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_el_table_column, {
                                          prop: "lastKnownVersion",
                                          label: "Version"
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["data"])
                                  ]))
                                : _createCommentVNode("", true),
                              (scope.row.roomDetails)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                    _createElementVNode("div", _hoisted_147, [
                                      _createElementVNode("div", _hoisted_148, [
                                        _hoisted_149,
                                        _createVNode(_component_el_switch, {
                                          disabled: "",
                                          modelValue: scope.row.roomDetails.enableMirroring,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.roomDetails.enableMirroring) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      (scope.row.roomDetails.hasSSPReceiver && _ctx.hasSignage)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                            _hoisted_151,
                                            _createVNode(_component_el_switch, {
                                              disabled: "",
                                              modelValue: scope.row.roomDetails.enableSignage,
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.roomDetails.enableSignage) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (scope.row.roomDetails.hasSSPReceiver && _ctx.hasAlerts)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                                            _hoisted_153,
                                            _createVNode(_component_el_switch, {
                                              disabled: "",
                                              modelValue: scope.row.roomDetails.enableAlerts,
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.roomDetails.enableAlerts) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_154, [
                                        _hoisted_155,
                                        _createVNode(_component_el_switch, {
                                          disabled: "",
                                          modelValue: scope.row.roomDetails.enableHigherResolutionBoolean,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.roomDetails.enableHigherResolutionBoolean) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                        (scope.row.roomDetails.enableHigherResolution != 2)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                                              _createVNode(_component_el_tooltip, {
                                                effect: "dark",
                                                content: "Overrides organization setting",
                                                placement: "bottom-start",
                                                "hide-after": 0
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Icon, {
                                                    class: "icon--danger icon--large ms-2 me-1 align-middle",
                                                    icon: _ctx.mdiAlertCircleOutline
                                                  }, null, 8, ["icon"])
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_157, [
                                      (scope.row.roomDetails.hasSSPReceiver)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                                            _hoisted_159,
                                            _createVNode(_component_el_switch, {
                                              disabled: "",
                                              modelValue: scope.row.roomDetails.showConnectionInfo,
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.roomDetails.showConnectionInfo) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (scope.row.roomDetails.hasSSPReceiver)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                                            _hoisted_161,
                                            _createTextVNode(_toDisplayString(_ctx.formatConnectionPosition(scope.row.roomDetails.connectionInfoPosition)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (scope.row.roomDetails.hasSSPReceiver)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                            _hoisted_163,
                                            _createVNode(_component_el_switch, {
                                              disabled: "",
                                              modelValue: scope.row.roomDetails.showSignageDateTimeBoolean,
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.roomDetails.showSignageDateTimeBoolean) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                            (scope.row.roomDetails.hasSSPReceiver && scope.row.roomDetails.showSignageDateTime != 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                                                  _createVNode(_component_el_tooltip, {
                                                    effect: "dark",
                                                    content: "Overrides organization setting",
                                                    placement: "bottom-start",
                                                    "hide-after": 0
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Icon, {
                                                        class: "icon--danger icon--large ms-2 me-1 align-middle",
                                                        icon: _ctx.mdiAlertCircleOutline
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (scope.row.roomDetails.hasSSPReceiver)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                                            _hoisted_166,
                                            _createTextVNode(_toDisplayString(scope.row.roomDetails.signageDateTimeLocationString) + " ", 1),
                                            (scope.row.roomDetails.hasSSPReceiver && scope.row.roomDetails.signageDateTimeLocation != 4)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                                  _createVNode(_component_el_tooltip, {
                                                    effect: "dark",
                                                    content: "Overrides organization setting",
                                                    placement: "bottom-start",
                                                    "hide-after": 0
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Icon, {
                                                        class: "icon--danger icon--large ms-2 me-1 align-middle",
                                                        icon: _ctx.mdiAlertCircleOutline
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_168, [
                                      (scope.row.roomDetails.hasSSPReceiver && _ctx.hasModeratorControls)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                                            _hoisted_170,
                                            _createVNode(_component_el_switch, {
                                              disabled: "",
                                              modelValue: scope.row.roomDetails.enableModeratorControls,
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.roomDetails.enableModeratorControls) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (scope.row.roomDetails.hasSSPReceiver && _ctx.hasModeratorControls && scope.row.roomDetails.enableModeratorControls && scope.row.roomDetails.moderatorConnectionType)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
                                            _hoisted_172,
                                            _createTextVNode(_toDisplayString(_ctx.formatModeratorType(scope.row.roomDetails.moderatorConnectionType)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (scope.row.roomDetails.hasSSPReceiver && _ctx.hasModeratorControls && scope.row.roomDetails.moderatorConnectionType == 'password' && scope.row.roomDetails.moderatorPassword)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                                            _hoisted_174,
                                            _createTextVNode(_toDisplayString(scope.row.roomDetails.moderatorPassword), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _hoisted_175,
                              (scope.row.roomDetails)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                                    _createElementVNode("div", _hoisted_177, [
                                      _createElementVNode("div", _hoisted_178, [
                                        _hoisted_179,
                                        _createVNode(_component_el_switch, {
                                          disabled: "",
                                          modelValue: scope.row.roomDetails.isOnboarding,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.roomDetails.isOnboarding) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ])
                                    ]),
                                    (scope.row.roomDetails.onboardingUser)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                                          _createElementVNode("div", _hoisted_181, [
                                            _hoisted_182,
                                            _createVNode(_component_router_link, {
                                              to: `/admin/users/${scope.row.roomDetails.onboardingUser.id}`
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(scope.row.roomDetails.onboardingUser.name), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["to"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (scope.row.roomDetails.onboardingUser)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_183, _hoisted_185))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])), [
                              [_directive_loading, !scope.row.roomDetails || scope.row.expandRoomLoading]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "id",
                          label: "Room ID",
                          sortable: "custom",
                          "show-overflow-tooltip": ""
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "roomName",
                          label: "Room Name",
                          sortable: "custom",
                          "show-overflow-tooltip": ""
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "roomCode",
                          label: "Room Code",
                          sortable: "custom",
                          "show-overflow-tooltip": ""
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "location, id",
                          label: "Location Name",
                          sortable: "custom",
                          "show-overflow-tooltip": ""
                        }, {
                          default: _withCtx((scope) => [
                            (scope.row.location && scope.row.location.parentName)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_186, _toDisplayString(scope.row.location.parentName), 1))
                              : (scope.row.location)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_187, _toDisplayString(scope.row.location.name), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_188, "-"))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "location, id",
                          label: "Sub Location Name",
                          sortable: "custom",
                          "show-overflow-tooltip": ""
                        }, {
                          default: _withCtx((scope) => [
                            (scope.row.location && scope.row.location.parentName)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_189, _toDisplayString(scope.row.location.name), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_190, "-"))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data", "onSortChange", "onExpandChange"]),
                    _hoisted_191,
                    _createVNode(_component_el_pagination, {
                      class: "d-flex justify-content-center",
                      background: "",
                      layout: "prev, pager, next",
                      total: _ctx.roomCount,
                      onCurrentChange: _ctx.handleRoomCurrentPageChange,
                      "current-page": _ctx.roomCurrentPage,
                      "onUpdate:currentPage": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.roomCurrentPage) = $event))
                    }, null, 8, ["total", "onCurrentChange", "current-page"])
                  ])), [
                    [_directive_loading, _ctx.roomsLoading]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "Populate Rooms",
                name: "populateRooms"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_RoomsImport, {
                    organization: _ctx.organization,
                    hasAlerts: _ctx.hasAlerts,
                    hasSignage: _ctx.hasSignage,
                    hasModeratorControls: _ctx.hasModeratorControls,
                    onImportComplete: _ctx.loadRooms
                  }, null, 8, ["organization", "hasAlerts", "hasSignage", "hasModeratorControls", "onImportComplete"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isPlanChangeConfirmationVisibile,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.isPlanChangeConfirmationVisibile) = $event)),
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    }, {
      title: _withCtx(() => [
        _hoisted_192
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_193, [
          _createVNode(_component_el_button, {
            disabled: _ctx.saving,
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.isPlanChangeConfirmationVisibile = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            disabled: _ctx.saving,
            "v-loading": _ctx.saving,
            type: "primary",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode("Update Plan")
            ]),
            _: 1
          }, 8, ["disabled", "v-loading", "onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(_ctx.totalChangeText), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isRefundModalVisibile,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.isRefundModalVisibile) = $event)),
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    }, {
      title: _withCtx(() => [
        _hoisted_194
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_199, [
          _createVNode(_component_el_button, {
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.isRefundModalVisibile = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            disabled: _ctx.refund.refundAmount == 0 || !_ctx.refund.refundAmount,
            type: "primary",
            onClick: _ctx.onRefund
          }, {
            default: _withCtx(() => [
              _createTextVNode("Refund")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_195,
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, [
              _createTextVNode("Via "),
              _createElementVNode("a", {
                href: _ctx.stripeCustomerUrl,
                target: "_blank",
                rel: "noreferrer noopener",
                class: "link"
              }, "Stripe", 8, _hoisted_196)
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("Via Admin Portal. Enter a refund amount that is less than or equal to the total refund amount and the latest invoice amount. "),
              _createVNode(_component_el_form, {
                class: "mt-3",
                ref: "refundForm",
                rules: _ctx.refundRules,
                model: _ctx.refund,
                "label-position": "top",
                "label-width": "120px",
                "hide-required-asterisk": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "refundAmount",
                    label: "Refund Amount"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.currentRefundAmount)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_197, "Refund amount available after a plan change: $" + _toDisplayString(_ctx.currentRefundAmount), 1))
                        : _createCommentVNode("", true),
                      (_ctx.latestInvoiceTotal !=0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_198, "Total charge from latest invoice: $" + _toDisplayString(_ctx.latestInvoiceTotal), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_input, {
                        "v-loading": _ctx.saving,
                        disabled: !_ctx.currentRefundAmount,
                        modelValue: _ctx.refund.refundAmount,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.refund.refundAmount) = $event)),
                        placeholder: "Enter refund amount"
                      }, null, 8, ["v-loading", "disabled", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["rules", "model"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [_directive_loading, _ctx.viewLoading]
  ])
}